import { render, staticRenderFns } from "./R15_rectangle.vue?vue&type=template&id=45252347&scoped=true"
import script from "./R15_rectangle.vue?vue&type=script&lang=js"
export * from "./R15_rectangle.vue?vue&type=script&lang=js"
import style0 from "./R15_rectangle.vue?vue&type=style&index=0&id=45252347&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45252347",
  null
  
)

export default component.exports